<script>
  import { onMount } from 'svelte';
  import { goto } from '$app/navigation';

  import { getProfileStore } from '@stores/profile';
  let appInvitesStore = getProfileStore('appInvitesStore');
  import AppInviteAjax from '@ajax/app_invite';
  import Mixpanel from '@utils/mixpanel';
  import { getCurrentUserStore } from '@stores/current_user';

  export let selected;
  export let fetchInvites = true;

  let currentUser = getCurrentUserStore('default');

  $: showInviteCodeNudge = currentUser?.show_app_invite_nudge;

  $: options = [
    {
      id: 1,
      label: 'Discover',
      image: '/images/bottom-bar/discover.svg',
      imageSelected: '/images/bottom-bar/discover-selected.svg',
      href: '/discover',
      alt: 'discover',
      action: () => {
        Mixpanel.track('Discover Click', {});
        window.discoverSelectedOption = undefined;
        window.discoverScrollPositions = {};
        window.discoverGroupsCache = {};
        goto('/discover');
      },
    },
    currentUser && currentUser.email && !currentUser.email.includes('@demo.benable.com')
      ? {
          id: 3,
          label: `<span style="position: relative">Invites
        ${
          showInviteCodeNudge
            ? '<div style="position: absolute; top: -6px; left: -22px; background: #FF5567; height: 12px; width: 12px; border-radius: 999px; border: 2px solid white;"></div>'
            : ''
        }</span>`,
          image: '/images/bottom-bar/invites.svg',
          imageSelected: '/images/bottom-bar/invites-selected.svg',
          action: () => {
            Mixpanel.track('Invites Click', {});
            goto('/app_invites');
          },
          alt: 'app-invites',
        }
      : undefined,
  ];

  let loadInvites = async function () {
    if (fetchInvites && currentUser && currentUser.id && appInvitesStore && appInvitesStore.length === 0) {
      try {
        let appInvites = await AppInviteAjax.fetch();
        appInvitesStore.set(appInvites);
      } catch {}
    }
  };

  onMount(() => {
    loadInvites();

    let unsub = currentUser.subscribe((x) => (currentUser = x));

    return () => {
      unsub();
    };
  });
</script>

<style style="text/scss" lang="scss">
  .navigation-container {
    display: flex;
    align-items: center;
    gap: 60px;

    .nav-btn {
      display: flex;
      align-items: center;
      gap: 16px;
      cursor: pointer;

      span {
        font-weight: 500;
        font-size: 14px;
        line-height: 8px;
        text-transform: capitalize;
        color: #a19bb8;
      }

      &:hover {
        span {
          color: #5e518e;
          opacity: 0.8;
        }
      }

      &.selected {
        span {
          color: #5e518e;
        }
      }
    }
  }
</style>

<div class="navigation-container">
  {#each options.filter((x) => x !== undefined) as option}
    {#key option}
      <a
        on:click|preventDefault={option.action}
        href={option.href || '#'}
        class="nav-btn {selected === option.alt ? 'selected' : ''}">
        <img src={selected === option.alt ? option.imageSelected : option.image} alt={option.alt} />
        <span>{@html option.label}</span>
      </a>
    {/key}
  {/each}
</div>
